<template>
  <div>
    <!-- toasts message -->
    <v-card color="grey lighten-4">
      <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    </v-card>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <!-- Insert Form  -->
    <insertForm
      :formSchema="formSchema"
      :assetSubCats.sync="assetSubCats"
      v-on:emitForm="close"
      v-if="showForm"
    ></insertForm>

    <v-container>
      <v-card>
        <v-card-title>
          <h2>Asset Item List</h2>
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="search"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-card-title>
        <span style="display:none;">{{serial=serialNumber}}</span>
        <v-data-table
          :headers="headers"
          :items="desserts"
          :pagination.sync="pagination"
          :total-items="totalDesserts"
          :loading="loading"
          class="elevation-4"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ serial++ }}</td>
            <td class="text-xs-left">{{ props.item.item_name }}</td>
            <td class="text-xs-left">{{ props.item.cat_name }}</td>
            <td class="text-xs-left">{{ props.item.sub_cat_name }}</td>
            <td class="text-xs-left">{{ props.item.unit_name }}</td>
            <td
              class="text-xs-left"
            >{{ (props.item.is_fixed_asset == 1) ? "Fixed Asset" : "Current Asset" }}</td>
            <td class="text-xs-left">{{ (props.item.is_active == 1) ? "Yes" : "No" }}</td>
            <td class="justify-center layout px-0">
              <v-btn
                icon
                class="mx-0"
                v-if="userRole.updateButton"
                @click="editItem(props.index,props.item)"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                v-if="userRole.deleteButton"
                @click="deleteItem(props.index, props.item.id)"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");
import insertForm from "./asset_item_form";

export default {
  components: {
    insertForm
  },

  data: () => ({
    showForm: false, // Add edit form controll during user permission
    dialog: false,
    totalItems: 0,

    items: [],

    //Delete data related instance--------
    delete_id: "",
    row_index: "",
    confirmModel: false,

    // snacber script instance ----------
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },

    formSchema: {
      id: "",
      item_name: "",
      cat_id: "",
      sub_cat_id: "",
      unit_id: "",
      is_fixed_asset: 1,
      is_active: 0
    },
    assetSubCats: [],

    /*############# Datatable #############*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      { text: "SL", value: "" },
      {
        text: "Item Name",
        align: "left",
        sortable: true,
        value: "item_name"
      },
      {
        text: "Asset Category",
        align: "left",
        sortable: true,
        value: "cat_name"
      },
      {
        text: "Asset Sub Category",
        align: "left",
        sortable: true,
        value: "sub_cat_name"
      },
      {
        text: "Measurement Unit",
        sortable: true,
        value: "unit_name"
      },
      {
        text: "Item Type",
        sortable: true,
        value: "is_fixed_asset"
      },
      {
        text: "Active",
        align: "left",
        value: "is_active"
      },
      { text: "Action", value: "" }
    ]
    /*############# /Datatable #############*/
  }),

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          if ( typeof(data.items) !== 'undefined') {
            this.desserts = data.items;
          }
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },
    // User Previlization methods
    userRole() {
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;
      return role;
    }
  },

  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "asset_item_info")
          .then(res => {
            this.showForm = this.userRole.saveButton;
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            // if (rowsPerPage > 0) {
            //   items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage);
            // }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    // Data edit form prepare
    editItem(index, data) {
      // Set asset sub cat list by cat id
      commonService
        .getAllDataById(data.cat_id, "get_asset_sub_cat_info_by_id")
        .then(res => {
          this.assetSubCats = res.data;
        });

      this.showForm = true;
      this.formSchema = data;
      this.row_index = index;
      // scroling to top
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    // data delete confirm modal
    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "asset_item").then(res => {
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);
        }
        this.close(res);
        this.confirmModel = false;
      });
    },

    //  Request response Massage !!!
    close(res) {
      this.showForm = this.userRole.saveButton;
      if (res.status == 1) {
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        if (res.action == "add") {
            this.desserts.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          this.$set(this.desserts, this.row_index, { ...res.data });
          this.row_index = "";
        }
        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
          behavior: "smooth"
        });
      } else {
        this.SnackbarVal.color = "error";
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        this.timeout = 10000;
      }
    }
    // End  Request response Massage !!!
  }
};
</script>



// WEBPACK FOOTER //
// src/components/asset/asset_item/asset_item_list.vue